function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import FullscreenItemPreload from './fullscreenItemPreload.js';
import { utils } from '../utils/utils';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';

var FullscreenText = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenText, _React$Component);

  function FullscreenText(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.props.actions.eventsListener(FULLSCREEN_EVENTS.ITEM_CREATED);

    return _this;
  }

  var _proto = FullscreenText.prototype;

  _proto.render = function render() {
    var item = this.props.item;
    var scale = Math.round(100 * (item.width / item.maxWidth) * this.props.currentWindow.scale.min(item)) / 100;
    var scaleFix = (scale - 1) / 2 * 100;
    var translate = this.props.isZoom ? 'translate(-50%, -50%)' : "translate(" + scaleFix + "%, " + scaleFix + "%)";
    return !this.props.isDummy ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FullscreenItemPreload, {
      item: item,
      loaded: true
    }), /*#__PURE__*/React.createElement("div", {
      className: 'fullscreen-content  fullscreen-item-visible fullscreen-item gallery-item-loaded pro-fullscreen-text-item',
      style: {
        width: item.maxWidth + 'px',
        height: item.maxHeight + 'px',
        WebkitTransform: utils.isMobile() ? translate + ' scale(' + scale + ')' : '',
        background: item.bgColor
      },
      key: 'text',
      "aria-label": "text item",
      dangerouslySetInnerHTML: {
        __html: item.html
      }
    })) : /*#__PURE__*/React.createElement("div", null);
  };

  return FullscreenText;
}(React.Component);

export default FullscreenText;